import { IComparator, StandardEntity } from '@infodata-group/inf-commons';
import { AbsenceTypeGroup } from './absence-type-group';

export class AbsenceType extends StandardEntity implements IComparator {
  public color: string;
  public borderColor: string;
  public group: AbsenceTypeGroup;
  public lock = false;
  public inBalance = false;
  public defaultHoursCount: number;
  public message: string[];

  constructor(
    id: string,
    label: string,
    group: AbsenceTypeGroup,
    color: string,
    borderColor: string,
  ) {
    super(id, label);
    this.color = color;
    this.borderColor = borderColor;
    this.group = group;
  }

  getId(): string {
    return this.id;
  }

  getLabel(): string {
    return this.label;
  }

  toString() {
    return this.label;
  }
}
